import { DirectiveHook, ObjectDirective } from 'vue';

export type Config = {
  requiredFields?: string[];
}

type MaybeAsteriskElement = { configRequired?: boolean };

function getAsteriskElement(el: HTMLElement): HTMLElement | null {
  for (let i = 0; i < el.children.length; i++) {
    if ((el.children.item(i)! as MaybeAsteriskElement).configRequired) {
      return el.children.item(i)! as HTMLElement;
    }
  }
  return null;
}

//v-config-required
const configRequired: DirectiveHook<HTMLElement, unknown, { config: Config, key: string }> =
  (el, binding: { value: { config: Config, key: string } }, vnode, oldVnode) => {
    if (el instanceof HTMLInputElement) {
      (el as HTMLInputElement).required = (binding.value.config.requiredFields ?? []).includes(binding.value.key);
    } else { //add asterisk to element
      const presentAsterisk = getAsteriskElement(el);
      if ((binding.value.config.requiredFields ?? []).includes(binding.value.key)) {
        if (!presentAsterisk) { // only append if not already present
          const asterisk = document.createElement('span');
          (asterisk as MaybeAsteriskElement).configRequired = true;
          asterisk.innerHTML = ' *';
          el.appendChild(asterisk);
        }
      } else {
        if (presentAsterisk) {
          el.removeChild(presentAsterisk);
        }
      }
    }
  };

export default {
  bind: configRequired,
  update: configRequired,
} as ObjectDirective<HTMLElement, { config: Config, key: string }>;